"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _immutable = require("immutable");

var PersonaRecord = (0, _immutable.Record)({
  age: null,
  challenge: '',
  createdAt: null,
  deleted: false,
  displayOrder: -1,
  education: '',
  goal: '',
  id: null,
  imageUrl: '',
  income: null,
  label: '',
  lists: (0, _immutable.List)(),
  location: '',
  name: '',
  other: '',
  portalId: null,
  role: '',
  updatedAt: null,
  value: null
}, 'PersonaRecord');

PersonaRecord.fromJS = function (json) {
  if (!json || (0, _typeof2.default)(json) !== 'object') {
    return json;
  }

  var persona = PersonaRecord(json);
  return persona;
};

PersonaRecord.savableFields = ['age', 'challenge', 'deleted', 'education', 'goal', 'imageUrl', 'income', 'label', 'lists', 'location', 'name', 'other', 'role'];

PersonaRecord.normalize = function (str, fieldName) {
  var specialCharacters = /[^a-zA-Z0-9]+/g;

  switch (fieldName) {
    case 'name':
      return str.replace(specialCharacters, '_');

    default:
      return str;
  }
};

var _default = PersonaRecord;
exports.default = _default;
module.exports = exports.default;